@if (isMobile || isTablet) {
  <!-- Mobile : bloc bleu nuit (logo + discussions + cloche, recherche toujours visible, onglets) -->
  <div class="mobile-header">
    <div class="mobile-header-top">
      <a class="mobile-brand" href="#" (click)="onGoDashboard()">
        <app-brand-mark [size]="34"></app-brand-mark>
        <span class="mobile-brand-name">Promo<span class="span-logo">Deep</span></span>
      </a>
      <div class="mobile-header-actions">
        <app-chat-button></app-chat-button>
        <app-notifications-bell [pushSupported]="pushSupported"
          [pushEnabled]="isSubscribedToPush" [pushBusy]="notificationsBusy" (togglePush)="toggleNotifications()">
        </app-notifications-bell>
      </div>
    </div>
    <form class="mobile-search" #f="ngForm" (ngSubmit)="onSearch(f.value)" role="search">
      <mat-icon class="mobile-search-icon" aria-hidden="true">search</mat-icon>
      <input #stateInput (keyup)="0" (input)="onSearchAutoComplete(f.value)" [matAutocomplete]="auto"
        type="search" [placeholder]="'header.searchPlaceholder' | t" [attr.aria-label]="'header.search' | t" ngModel
        name='searchKeyWords' [(ngModel)]="search">
      <mat-autocomplete #auto="matAutocomplete">
        @if (searchProducts) {
          <div>
            @for (searchProductDto  of searchProducts; track searchProductDto ) {
              <mat-option class="option-autocomplete" (onSelectionChange)="stateInput.value !=undefined"
                [value]="searchProductDto.searchProduct">
                @if (searchProductDto.pictureUrl) {
                  <img width="32" src={{searchProductDto.pictureUrl}} class="logo">
                }
                <span>{{ searchProductDto.searchProduct }}</span>
              </mat-option>
            }
          </div>
        }
      </mat-autocomplete>
    </form>
    <nav class="mobile-tabs" [attr.aria-label]="'header.menu' | t">
      <a routerLink="/" (click)="onDashboard()" class="mobile-tab" [class.active]="mobileTab === 'deals'">{{ 'header.promotions' | t }}</a>
      <a (click)="onFilterByPromotionCode()" class="mobile-tab" [class.active]="mobileTab === 'codes'" href="javascript:void(0)">{{ 'header.promoCodes' | t }}</a>
      <a (click)="OpenMenuMobile()" class="mobile-tab" [class.active]="mobileTab === 'categories'" href="javascript:void(0)">{{ 'header.categories' | t }}</a>
    </nav>
  </div>
}
@if (isDesktopDevice && showTopBanner) {
  <div class="top-banner">
    <span class="top-banner-text">
      <mat-icon class="top-banner-icon">bolt</mat-icon>
      {{ 'header.extensionBanner' | t }}
    </span>
    <div class="top-banner-actions">
      <button type="button" class="btn-pill btn-pill-accent" (click)="openChromeExtension()">{{ 'header.addToChrome' | t }}</button>
      <button type="button" class="top-banner-close" [attr.aria-label]="'common.close' | t" (click)="dismissTopBanner()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
}

@if (isDesktopDevice) {
  <nav class="navbar navbar-expand-lg navbar-promodeep">
    <div class="container">
      <div class="container-fluid main-bar">
        <a class="navbar-brand" href="#">
          <div class="branding logo-desktop">
            <app-brand-mark [size]="38"></app-brand-mark>
            <a class="a-logo" href="#" (click)="onGoDashboard()"> Promo<span class="span-logo">Deep</span></a>
          </div>
        </a>
        <form class="d-flex search-form" #f="ngForm" (ngSubmit)="onSearch(f.value)">
          <mat-icon class="search-icon">search</mat-icon>
          <input #stateInput (keyup)="0" (input)="onSearchAutoComplete(f.value)" [matAutocomplete]="auto"
            class="form-control" type="search" [placeholder]="'header.searchPlaceholder' | t" [attr.aria-label]="'header.search' | t" ngModel
            name='searchKeyWords' [(ngModel)]="search" (focus)="onClickToSearch()" (blur)="onClickToSearch()">
          <mat-autocomplete #auto="matAutocomplete">
            @if (searchProducts) {
              <div>
                @for (searchProductDto  of searchProducts; track searchProductDto ) {
                  <mat-option class="option-autocomplete" (onSelectionChange)="stateInput.value !=undefined"
                    [value]="searchProductDto.searchProduct">
                    @if (searchProductDto.pictureUrl) {
                      <img src={{searchProductDto.pictureUrl}} class="logo">
                    }
                    <span>{{ searchProductDto.searchProduct }}</span>
                  </mat-option>
                }
              </div>
            }
          </mat-autocomplete>
        </form>
        <div class="main-bar-actions">
          <app-chat-button></app-chat-button>
          <!-- Même cloche que sur mobile : derniers deals + activation des notifications push -->
          <app-notifications-bell [pushSupported]="pushSupported"
            [pushEnabled]="isSubscribedToPush" [pushBusy]="notificationsBusy" (togglePush)="toggleNotifications()">
          </app-notifications-bell>
          @if (cookiesNewsletter =='2') {
            <span class="action-link" (click)="openDialogNewsLetter()">
              <mat-icon matBadge="!" matBadgeColor="primary">email</mat-icon>
            </span>
          }
          @if (cookiesNewsletter ==='1') {
            <span class="action-link" (click)="openDialogNewsLetter()">
              <mat-icon>email</mat-icon>
            </span>
          }
          @if (cookiesNewsletter ==='0') {
            <span class="action-link" (click)="openDialogNewsLetter()">
              <mat-icon>email</mat-icon>
            </span>
          }
          <a routerLink="/" (click)="onDashboard()" class="nav-link-header" [class.active]="selectedCategoryKey === null">{{ 'header.forYou' | t }}</a>
          <a routerLink="/promotionCode" (click)="onFilterByPromotionCode()" class="nav-link-header">{{ 'header.promoCodes' | t }}</a>
          <a routerLink="/pres-de-moi" routerLinkActive="active" class="nav-link-header">{{ 'nearby.nav' | t }}</a>
          <a routerLink="/compte/club" class="nav-link-header">{{ 'header.clubPoints' | t }}</a>
          <button type="button" class="btn-pill btn-pill-outline" (click)="onPoster()">
            <mat-icon>add</mat-icon>
            {{ 'header.post' | t }}
          </button>
          @if (isLoggedIn==false) {
            <span class="action-link" (click)="openDialogLogin()">
              <mat-icon>person_outline</mat-icon>
              <span>{{ 'header.loginOrSignup' | t }}</span>
            </span>
          }
          @if (isLoggedIn==true) {
            <span class="action-link" [matMenuTriggerFor]="menu">
              <span class="avatar-online">
                @if (userHasAvatar) {
                  <img [src]="userAvatar" width="30" height="30" class="header-avatar" [alt]="'header.myAccount' | t" />
                } @else {
                  <span class="header-avatar header-avatar-initial" [attr.aria-label]="'header.myAccount' | t">{{ userInitial }}</span>
                }
              </span>
            </span>
          }
          <mat-menu #menu="matMenu">
            @for (item of accountSections; track item.id) {
              <button mat-menu-item [routerLink]="['/compte', item.id]">
                <mat-icon>{{item.icon}}</mat-icon>
                <span>{{ item.labelKey | t }}</span>
              </button>
            }
            <mat-divider></mat-divider>
            <button mat-menu-item routerLink="/settings/profil">
              <mat-icon>settings</mat-icon>
              <span>{{ 'header.settings' | t }}</span>
            </button>
            <button mat-menu-item (click)="logout()">
              <mat-icon>exit_to_app</mat-icon>
              <span>{{ 'header.logout' | t }}</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </nav>
}
<!-- <div class="container">
<nav mat-button-toggle-button *ngIf="isDesktopDevice" mat-tab-nav-bar class="ms-nav-list-scroll"
  disablePagination="false" (selectedTabChange)="tabChanged($event)" mat-align-tabs="center"
  backgroundColor="backgroundThemeColor">

  <a routerLink="/" (click)="onDashboard()" [routerLinkActive]="'activeItem'" mat-tab-link>
    <mat-icon>notifications_active</mat-icon>
    PROMOTIONS
  </a>

  <a routerLink="/" style="color: rgb(255, 255, 255);" (click)="onFilterByPromotionCode()"
    [routerLinkActive]="'activeItem'" mat-tab-link>
    <mat-icon>loyalty</mat-icon> CODES PROMO
  </a>

  <a style="color: rgb(255, 255, 255);" (click)="diplayNavCategories()" [routerLinkActive]="'activeItem'"
    id="navbarDropdown" mat-tab-link>
    <mat-icon>filter_list</mat-icon>
    Categories
  </a>
</nav>


</div> -->


<div class="container">
  @if (isDesktopDevice) {
    <nav mat-button-toggle-button mat-tab-nav-bar class="category-bar" disablePagination="false"
      (selectedTabChange)="tabChanged($event)" mat-align-tabs="center">
      <a routerLink="/" (click)="onDashboard()" [class.activeItem]="selectedCategoryKey === null" mat-tab-link>
        <span>{{ 'categories.all' | t }}</span>
      </a>
      <a routerLink="/" (click)="onFilterCategory('electro')" [class.activeItem]="selectedCategoryKey === 'electro'" mat-tab-link>
        <mat-icon>desktop_windows</mat-icon>
        <span>{{ 'categories.electro' | t }}</span>
      </a>
      <a routerLink="/" (click)="onFilterCategory('videoGame')" [class.activeItem]="selectedCategoryKey === 'videoGame'" mat-tab-link>
        <mat-icon>videogame_asset</mat-icon>
        {{ 'categories.videoGame' | t }}
      </a>
      <a routerLink="/" (click)="onFilterCategory('fashion')" [class.activeItem]="selectedCategoryKey === 'fashion'" mat-tab-link>
        <mat-icon> local_mall</mat-icon>
        {{ 'categories.fashion' | t }}
      </a>
      <a routerLink="/" (click)="onFilterCategory('cosmetic')" [class.activeItem]="selectedCategoryKey === 'cosmetic'" mat-tab-link>
        <mat-icon>spa</mat-icon>
        {{ 'categories.cosmetic' | t }}
      </a>
      <a routerLink="/" (click)="onFilterCategory('sport')" [class.activeItem]="selectedCategoryKey === 'sport'" mat-tab-link>
        <mat-icon>fitness_center</mat-icon>
        {{ 'categories.sport' | t }}
      </a>
      <a routerLink="/" (click)="onFilterCategory('family')" [class.activeItem]="selectedCategoryKey === 'family'" mat-tab-link>
        <mat-icon>child_friendly</mat-icon>
        {{ 'categories.family' | t }}
      </a>
      <a routerLink="/" (click)="onFilterCategory('home')" [class.activeItem]="selectedCategoryKey === 'home'" mat-tab-link>
        <mat-icon>event_seat</mat-icon>
        {{ 'categories.home' | t }}
      </a>
      <a routerLink="/" (click)="onFilterCategory('animal')" [class.activeItem]="selectedCategoryKey === 'animal'" mat-tab-link>
        <mat-icon>pets</mat-icon>
        {{ 'categories.animal' | t }}
      </a>
      <a routerLink="/" (click)="onFilterCategory('trip')" [class.activeItem]="selectedCategoryKey === 'trip'" mat-tab-link>
        <mat-icon>airplanemode_active</mat-icon>
        {{ 'categories.trip' | t }}
      </a>
      <a routerLink="/" (click)="onFilterCategory('mechanic')" [class.activeItem]="selectedCategoryKey === 'mechanic'" mat-tab-link>
        <mat-icon> directions_car</mat-icon>
        {{ 'categories.mechanic' | t }}
      </a>
      <!--  <a routerLink="/" (click)="onFilterCategory('training')" [routerLinkActive]="'activeItem'" mat-tab-link>
      <mat-icon>school</mat-icon>
      Cultures & formations
    </a> -->
    <!-- <a routerLink="/" (click)="onFilterCategory('deal')" [routerLinkActive]="'activeItem'" mat-tab-link>
    <mat-icon>settings_phone</mat-icon>
    Forfaits
  </a> -->
  <a routerLink="/" (click)="onFilterCategory('finance')" [class.activeItem]="selectedCategoryKey === 'finance'" mat-tab-link>
    <mat-icon>account_balance</mat-icon>
    {{ 'categories.finance' | t }}
  </a>
  <!-- <a routerLink="/" (click)="onFilterCategory('featuredBrand')" [routerLinkActive]="'activeItem'" mat-tab-link>
  <mat-icon> local_offer</mat-icon>
  Vedette Brands
</a> -->
<!-- <a routerLink="/" (click)="onFilterCategory('gardenDIY')" [routerLinkActive]="'activeItem'" mat-tab-link>
<mat-icon>build</mat-icon>
Jardin & Bricolage
</a> -->
<!-- <a routerLink="/" (click)="onFilterCategory('service')" [routerLinkActive]="'activeItem'" mat-tab-link>
<mat-icon>room_service</mat-icon>
Services
</a> -->
<!-- <a routerLink="/" (click)="onFilterCategory('grocery')" [routerLinkActive]="'activeItem'" mat-tab-link>
<mat-icon>add_shopping_cart</mat-icon>
Courses & Épicerie
</a>
<a routerLink="/" (click)="onFilterCategory('crypto')" [routerLinkActive]="'activeItem'" mat-tab-link>
  <mat-icon>trending_up</mat-icon>
  Crypto
</a>
<a routerLink="/" (click)="onFilterCategory('free')" [routerLinkActive]="'activeItem'" mat-tab-link>
  <mat-icon>card_giftcard</mat-icon>
  Gratuit
</a> -->
</nav>
}


</div>
